import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App";
import router from "./router";
import VueAwesomeSwiper from "vue-awesome-swiper";
import directives from "./directives/index";

import "swiper/dist/css/swiper.css";

Vue.directive("fixed", directives.fixed);
Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

Vue.prototype.$baseUrl = "https://admin.ukcec.com/home/index/";
Vue.prototype.$basePicUrl = "https://admin.ukcec.com/Public/Uploads/";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  created() {
    if (!this.IsPC()) {
      window.location.href = location.protocol + "//" + location.host + "/m/#/";
    }
  },
  mounted() {
    const that = this;
    that.resetFontSize();
    window.onresize = () => {
      return (() => {
        that.resetFontSize();
      })();
    };
  },
  methods: {
    resetFontSize() {
      let rootHtml = document.documentElement;
      let deviceWidth = rootHtml.clientWidth;

      rootHtml.style.fontSize = (deviceWidth * 100) / 1920 + "px";
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js